import React from "react";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Container, Typography, Button, Link } from "@mui/material";
import { pageTitle, lead, h2Rule, paragraph, ctaSx, softCard, fadeUp } from "../theme/marketingStyles";

/** /tarieven — sessieprijzen vooraf, wat de gratis kennismaking inhoudt, en
 *  wat de werkgeversbundel dekt. Eerlijke totaalprijzen; terugbetaling staat
 *  op /terugbetaling. Geen superlatieven, geen garanties. */
export default function Pricing() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Groen = gratis/positief (kennismaking), oranje/goud = betaalde sessies.
  const cards = [
    { key: "intro", price: t("pricing.introPrice"), accent: "#3E7D4E" },
    { key: "coaching", price: t("pricing.coachingPrice"), accent: "#C8682E" },
    { key: "therapy", price: t("pricing.therapyPrice"), accent: "#7A5512" },
  ];

  return (
    <Box sx={{ bgcolor: "background.default" }}>
      <Container maxWidth="md" sx={{ pt: { xs: 6, sm: 9 }, pb: { xs: 7, sm: 10 } }}>
        <Box sx={{ textAlign: { xs: "center", md: "left" }, ...fadeUp(0) }}>
          <Typography variant="h1" sx={pageTitle}>{t("pricing.title")}</Typography>
          <Typography sx={{ ...lead, maxWidth: 640, mx: { xs: "auto", md: 0 } }}>{t("pricing.intro")}</Typography>
        </Box>

        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" }, gap: 2.5, mb: 2, ...fadeUp(120) }}>
          {cards.map((c) => (
            <Box key={c.key} sx={{ ...softCard, p: 3.5, textAlign: { xs: "center", sm: "left" } }}>
              <Typography variant="h3" sx={{ fontSize: "1.1rem", mb: 1 }}>{t(`pricing.${c.key}Title`)}</Typography>
              <Typography sx={{ fontFamily: "var(--font-display)", fontSize: "1.7rem", fontWeight: 600, color: c.accent, mb: 1 }}>{c.price}</Typography>
              <Typography sx={{ m: 0, fontSize: ".95rem", color: "text.secondary" }}>{t(`pricing.${c.key}Body`)}</Typography>
            </Box>
          ))}
        </Box>
        <Typography variant="caption" sx={{ display: "block", mb: 2, color: "text.secondary", lineHeight: 1.6 }}>{t("pricing.totalNote")}</Typography>

        <Typography variant="h2" sx={h2Rule}>{t("pricing.reimbTitle")}</Typography>
        <Typography sx={paragraph}>
          {t("pricing.reimbBody")}{" "}
          <Link component={RouterLink} to="/terugbetaling">{t("pricing.reimbLink")}</Link>
        </Typography>

        <Typography variant="h2" sx={h2Rule}>{t("pricing.employerTitle")}</Typography>
        <Typography sx={paragraph}>{t("pricing.employerBody1")}</Typography>
        <Typography sx={paragraph}>
          {t("pricing.employerBody2")}{" "}
          <Link component={RouterLink} to="/voor-werkgevers">{t("pricing.employerLink")}</Link>
        </Typography>

        <Typography variant="h2" sx={h2Rule}>{t("pricing.feesTitle")}</Typography>
        <Typography sx={paragraph}>{t("pricing.feesBody")}</Typography>

        <Box sx={{ mt: 7, textAlign: "center" }}>
          <Button variant="contained" size="large" onClick={() => navigate("/start")} sx={{ minWidth: 240, ...ctaSx }}>
            {t("pricing.cta")}
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
